import React, { useEffect, useState, useContext } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import DatePicker from "react-datepicker";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import moment from "moment";
import { token_api } from "../../Utils/Network";
import Snackbar from "@mui/material/Snackbar";
// import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from "@mui/material/Alert";

const dayOptions = [
  { label: "Sun", value: "sunday" },
  { label: "Mon", value: "monday" },
  { label: "Tue", value: "tuesday" },
  { label: "Wed", value: "wednesday" },
  { label: "Thu", value: "thursday" },
  { label: "Fri", value: "friday" },
  { label: "Sat", value: "saturday" },
];
const batchData = {
  colour: "#D581D6",
  sunday: true,
  monday: true,
  tuesday: true,
  wednesday: true,
  thursday: true,
  friday: true,
  saturday: true,
  discount_type: "Percentage",
  commence: moment(),
  conclude: moment(),
  session_name: "",
  price: "",
  duration: 60,
  capacity: 1,
};

const Setting = () => {
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [data, setData] = useState(batchData);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [open, setOpen] = React.useState(false);
  const [meetLink, setMeetLink] = useState("");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [dataPresent, setDataPresent] = useState(false);


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const createBatchHandler = () => {
    if (!data.session_name || data.price === "") {
      alert("Please fill all the details (Session Name and Price are required).");
      return;
    }

    if (!meetLink || !meetLink.trim()) {
      setError(true);
      setHelperText("Google Meet Link is required. Please enter a valid Google Meet link.");
      alert("Please enter a Google Meet Link. A valid Google Meet link is required to create slots.");
      return;
    }

    const googleMeetRegex =
      /^https:\/\/meet\.google\.com\/[a-zA-Z0-9\-]{10,14}$/;
    if (!googleMeetRegex.test(meetLink.trim())) {
      setError(true);
      setHelperText("Please enter a valid Google Meet link (e.g. https://meet.google.com/abc-defg-hij).");
      alert("Please enter a valid Google Meet link (e.g. https://meet.google.com/abc-defg-hij).");
      return;
    }

    const daysList = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    const myArray = [];
    for (const [key, value] of Object.entries(data)) {
      if (typeof value === "boolean" && value) {
        let getIndex = daysList.indexOf(key) + 1;
        if (getIndex > 0) myArray.push(getIndex);
      }
    }

    if (myArray.length === 0) {
      alert("Please select at least one day of the week.");
      return;
    }

    const effectiveEndDate = endDate < startDate ? startDate : endDate;
    const coms = moment(data.commence).format("HH:mm:ss");
    const conc = moment(data.conclude).format("HH:mm:ss");
    const starts = moment(startDate).format("DD-MM-YYYY");
    const ends = moment(effectiveEndDate).format("DD-MM-YYYY");

    const demo = {
      session_name: data.session_name,
      price: +data.price,
      start: starts,
      end: ends,
      commence: coms,
      conclude: conc,
      days: myArray,
      duration: +data.duration || 60,
      capacity: +data.capacity || 1,
      meet_link: meetLink.trim(),
    };

    token_api
      .post("counseling/v2/all_slots/register_instructor/", demo)
      .then((res) => {
        if (res.status === 200) {
          if (meetLink) {
            try {
              localStorage.setItem("counsellor_last_meet_link", meetLink.trim());
            } catch (e) {}
          }
          setOpen(true);
        }
      })
      .catch((err) => {
        console.error("Slot creation error:", err?.response?.data || err);
        alert(err?.response?.data?.message || err?.response?.data?.info || "Failed to create slots. Please check timings.");
      });
  };

  useEffect(() => {
    // 1. Immediately prefill from localStorage if available
    try {
      const cachedLink = localStorage.getItem("counsellor_last_meet_link");
      if (cachedLink) {
        setMeetLink(cachedLink);
        setDataPresent(true);
      }
    } catch (e) {}

    // 2. Fetch fresh meet link from backend
    getuserMeetLink();
  }, []);

  const getuserMeetLink = () => {
    token_api
      .get(`/profile/instructor_meet_link/`)
      .then((res) => {
        const link =
          res?.data?.data?.[0]?.meet_link ??
          res?.data?.data?.meet_link ??
          res?.data?.[0]?.meet_link ??
          res?.data?.meet_link ??
          "";
        console.log("getuserMeetLink:", link);
        if (link && link.trim() !== "") {
          setMeetLink(link.trim());
          setDataPresent(true);
          try {
            localStorage.setItem("counsellor_last_meet_link", link.trim());
          } catch (e) {}
        }
      })
      .catch((err) => {
        console.log("Error fetching meet link:", err);
      });
  };

  const handleMeetLinks = (e) => {
    const googleMeetRegex =
      /^https:\/\/meet\.google\.com\/[a-zA-Z0-9\-]{10,14}$/;
    const { value } = e.target;
    setMeetLink(value);
    if (value && !googleMeetRegex.test(value.trim())) {
      setError(true);
      setHelperText("Please enter a valid Google Meet link (e.g. https://meet.google.com/abc-defg-hij).");
    } else {
      setError(false);
      setHelperText("");
    }
  };

  const saveMeetLink = () => {
    if (!meetLink || error) {
      alert("Please enter a valid Google Meet link before saving.");
      return;
    }
    const cleanLink = meetLink.trim();
    token_api
      .post(`/profile/instructor_meet_link/`, { meet_link: cleanLink })
      .then((res) => {
        setDataPresent(true);
        try {
          localStorage.setItem("counsellor_last_meet_link", cleanLink);
        } catch (e) {}
        alert("Google Meet link updated successfully!");
      })
      .catch((err) => {
        console.error("Error updating meet link:", err);
        // Fallback to patch
        token_api
          .patch(`/profile/instructor_meet_link/`, { meet_link: cleanLink })
          .then((res) => {
            setDataPresent(true);
            try {
              localStorage.setItem("counsellor_last_meet_link", cleanLink);
            } catch (e) {}
            alert("Google Meet link updated successfully!");
          })
          .catch((patchErr) => {
            alert(patchErr?.response?.data?.detail || "Failed to update Google Meet link.");
          });
      });
  };

  return (
    <div>
      <div>
        <div>
          <Grid xs={12} container style={{ padding: "2% 5%" }}>
            <Grid
              style={{ paddingLeft: "2%" }}
              container
              spacing={2}
              xs={12}
              md={6}
            >
              <Grid item xs={12}>
                <h2 style={{ color: "#313E6C", margin: 0 }}>
                  Create New Session
                </h2>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  // required
                  id="outlined-required"
                  label="Session Name"
                  variant="outlined"
                  name="session_name"
                  size="small"
                  fullWidth
                  onChange={(e) =>
                    setData({ ...data, session_name: e.target.value })
                  }
                  value={data.session_name}
                />
              </Grid>
              <Grid item xs={12} className="weekday-container">
                <p style={{ color: "#313E6C", margin: 0, fontWeight: "bold" }}>
                  Select Days
                </p>
                <Checkbox
                  checked={
                    data.sunday &&
                    data.monday &&
                    data.tuesday &&
                    data.wednesday &&
                    data.thursday &&
                    data.friday &&
                    data.saturday
                  }
                  onChange={(e, v) =>
                    setData({
                      ...data,
                      sunday: v,
                      monday: v,
                      tuesday: v,
                      wednesday: v,
                      thursday: v,
                      friday: v,
                      saturday: v,
                    })
                  }
                  // color="primary"
                  style={{ marginTop: -3, color: "#12878b" }}
                />
                <span>Select all</span>
                <br />
                {dayOptions.map((d) => (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      marginTop: -5,
                    }}
                    key={d.value}
                  >
                    <Checkbox
                      required
                      checked={data[d.value]}
                      style={{ color: "#12878b" }}
                      onChange={(e, checkedState) =>
                        setData({ ...data, [d.value]: checkedState })
                      }
                    />
                    <span>{d.label}</span>
                  </div>
                ))}
                {/* <p className="batch-error-message-c">{errorMessages.errorDay}</p> */}
              </Grid>
              {/* 
              <Button
                color="primary"
                variant="contained"
                style={{
                  width: "100%",
                  margin: "2% 10% 0",
                  borderRadius: "0.6rem",
                  fontSize: "1rem",
                  height: "2.5rem",
                  backgroundColor: "#EF9000" 
                }}
                onClick={createBatchHandler}
              >
                Create
              </Button> 
              */}
            </Grid>
            <Grid
              style={{ paddingLeft: "2%" }}
              container
              spacing={2}
              xs={12}
              md={6}
              sx={{ display: "flex", flexWrap: "wrap", marginTop: "20px" }}
            >
              {/* wrapper box added */}

              <Box sx={{ marginLeft: "10px" }}>
                <Grid style={{ marginTop: "2%" }} item xs={6}>
                  <Box>
                    <Typography sx={{ color: "#696984" }}>
                      Start date
                    </Typography>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        setStartDate(date);
                        if (endDate < date) {
                          setEndDate(date);
                        }
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography sx={{ color: "#696984" }}>End date</Typography>
                    <DatePicker
                      selected={endDate}
                      minDate={startDate}
                      onChange={(date) => setEndDate(date)}
                    />
                  </Box>
                </Grid>
              </Box>

              <Box sx={{ marginLeft: "10px" }}>
                <Grid style={{ marginTop: "2%" }} item xs={6}>
                  {/* new time picker */}
                  <Box xs={6}>
                    <Typography sx={{ color: "#696984" }}>
                      Start time
                    </Typography>
                    <TimePicker
                      showTodayButton
                      required
                      todayLabel="now"
                      label="Start Time"
                      minutesStep={5}
                      value={data.commence}
                      onChange={(e, v) => setData({ ...data, commence: e })}
                      size="small"
                      inputVariant="outlined"
                      fullWidth
                      autoOk
                    />
                  </Box>

                  <Box xs={6}>
                    <Typography sx={{ color: "#696984" }}>End time</Typography>
                    <TimePicker
                      showTodayButton
                      required
                      todayLabel="now"
                      label="Start Time"
                      minutesStep={5}
                      value={data.conclude}
                      onChange={(e, v) => setData({ ...data, conclude: e })}
                      size="small"
                      inputVariant="outlined"
                      fullWidth
                      autoOk
                    />
                  </Box>
                </Grid>
              </Box>

              <Grid item xs={12}>
                <TextField
                  required
                  id="outlined-required"
                  label="Slot Duration (minutes)"
                  variant="outlined"
                  name="duration"
                  onChange={(e) =>
                    setData({ ...data, duration: e.target.value })
                  }
                  value={data.duration}
                  type="number"
                  size="small"
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="outlined-required"
                  label="Price"
                  variant="outlined"
                  name="price"
                  onChange={(e) => setData({ ...data, price: e.target.value })}
                  value={data.price}
                  type="number"
                  size="small"
                  // error={errors.price ? true : false}
                  // helperText={errors.showError && errors.price}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="outlined-required"
                  label="Slot Limit / Capacity (Students per Slot)"
                  variant="outlined"
                  name="capacity"
                  helperText="Number of students allowed to book this time slot (e.g. 1 or 2)"
                  onChange={(e) => setData({ ...data, capacity: e.target.value })}
                  value={data.capacity}
                  type="number"
                  inputProps={{ min: 1, max: 10 }}
                  size="small"
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="outlined-meet-link"
                  label="Google Meet Link (Required)"
                  variant="outlined"
                  name="meet_link"
                  placeholder="https://meet.google.com/xxx-yyyy-zzz"
                  onChange={(e) => handleMeetLinks(e)}
                  value={meetLink}
                  type="text"
                  size="small"
                  error={error}
                  helperText={helperText || "Required: This Google Meet link will be automatically sent in the confirmation email to students who book your slot."}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </Grid>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", alignItems: "center", margin: "2% 5% 0" }}>
            <Button
              color="primary"
              variant="contained"
              style={{
                minWidth: "14rem",
                borderRadius: "0.6rem",
                fontSize: "1rem",
                height: "2.8rem",
                backgroundColor: "#12878b",
              }}
              onClick={createBatchHandler}
            >
              Create Slots
            </Button>

            <Button
              color="primary"
              variant="outlined"
              style={{
                minWidth: "14rem",
                borderRadius: "0.6rem",
                fontSize: "0.95rem",
                height: "2.8rem",
              }}
              onClick={saveMeetLink}
            >
              {dataPresent ? "Update Meet Link Only" : "Save Meet Link"}
            </Button>
          </div>
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert
              onClose={handleClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              Successfully created
            </Alert>
          </Snackbar>
        </div>
        {/* <button onClick={() => goToPath('/counsellor')}>Back</button> */}
      </div>
    </div>
  );
};

export default Setting;
